import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CartItemContextSource } from "@spartacus/cart/base/components";
import { CartItemContext } from "@spartacus/cart/base/root";
import { ICON_TYPE } from "@spartacus/storefront";
import { WindowRef } from '@spartacus/core';
import { SpartacusCartItemComponent } from '../cart-item/cart-item.component';
import { GenGoogleAnalyticsService } from 'src/app/generac/services/google-analytics.service';

@Component({
  selector: 'gen-cart-item',
  templateUrl: './cart-item.component.html',
  providers: [
    CartItemContextSource,
    { provide: CartItemContext, useExisting: CartItemContextSource },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GenCartItemComponent extends SpartacusCartItemComponent implements OnInit {

  @Input() navigatedToPpdFrom: string;
  @Input() gaListName: string;
  @Input() gaEntrySource: string;

  @ViewChild('consumerDetailsSection', { read: ElementRef }) consumerDetailsSection: ElementRef;

  isCheckoutPage: boolean;
  isServicePartsEnabled: boolean;
  isReviewOrder: boolean;
  isOrderConfirmation: boolean;
  sppFormValue: any;
  isConsumerDetailsSectionExpanded: boolean = true;
  isMobileView: boolean = false;

  constructor(
    protected override cartItemContextSource: CartItemContextSource,
    protected winRef: WindowRef,
    protected googleAnalyticsService: GenGoogleAnalyticsService,
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    super(cartItemContextSource);
    this.isCheckoutPage = this.winRef.location.href.includes('checkout/') || this.winRef.location.href.includes('order-confirmation');
    this.isServicePartsEnabled = JSON.parse(this.winRef.localStorage.getItem('isServicePartsEnabled'));
    this.isReviewOrder = this.winRef.location.href.includes('checkout/review-order');
    this.isOrderConfirmation = this.winRef.location.href.includes('order-confirmation')
  }

  protected readonly ICON_TYPE = ICON_TYPE;

  ngOnInit(): void {
    if (this.item?.sppFormValue) {
      this.sppFormValue = JSON.parse(this.item?.sppFormValue);
    }
    this.isMobileView = this.winRef?.nativeWindow.innerWidth < 768;
  }

  expandConsumerDetailsSection(): void {
    this.isConsumerDetailsSectionExpanded = !this.isConsumerDetailsSectionExpanded;
    this.onResize();
  }

  isBuilderSpp(): boolean {
    return Array.isArray(this.sppFormValue) ? this.sppFormValue.some((group: any) => group.fields?.some((field: any) => field.code === 'builderName')) : this.sppFormValue?.fields?.some((field: any) => field.code === 'builderName');
  }

  handleRemoveItem(item: any): void {
    const product = {
      ...item.product,
      price: item.basePrice,
    }

    this.googleAnalyticsService.sendGaEvent('remove_from_cart', {
      currency: item.totalPrice.currencyIso,
      value: item.totalPrice.value,
      items: [this.googleAnalyticsService.mapProductToGaItem(product, 0, item.quantity)]
    });

    this.removeItem();
  }

  onResize(hasSkipCondition?: boolean): void {
    if (hasSkipCondition) {
      return;
    }

    const consumerDetailsSectionElHeight = this.isConsumerDetailsSectionExpanded ? (this.consumerDetailsSection?.nativeElement?.firstChild?.clientHeight + 16) : 0;

    this.el.nativeElement.firstChild.childNodes
      .forEach((item: HTMLElement, index: number, items: HTMLElement[]) => {
        this.renderer.setStyle(
          item,
          'padding-bottom',
          `${consumerDetailsSectionElHeight}px`
        );
      });
  }
}
